import { useAccount, useMsal } from "@azure/msal-react";
import { Login } from "@mui/icons-material";
import { Chip, Typography } from "@mui/material";
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";
import { VIEWER_TOKEN_KEY } from "e.sic-platform.webclient/src/services/authentication/AuthService";
import { appSessionStorage } from "e.sic-platform.webclient/src/services/storage/SessionStorageService";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import useUrlQueryParams from "e.sic-platform.webclient/src/services/url/UrlQueryService";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";

export default observer(function LoginButton() {
    const { instance, accounts, inProgress } = useMsal();
    const account = useAccount(accounts[0] || {});
    const { authToken } = useUrlQueryParams();

    const login = useCallback(() => {
        const viewerAuthToken = authToken || appSessionStorage.getStorageItem(VIEWER_TOKEN_KEY);
        authentication.loginAndObtainToken(instance, account, viewerAuthToken, inProgress);
    }, [authentication])

    return (
        <Chip 
            sx={{mr: 1}} 
            deleteIcon={<Login fontSize="large" />}
            onDelete={login} 
            color="primary" 
            onClick={login} 
            variant="outlined" 
            label={<Typography variant="body1">{translationService.translate("general.login")}</Typography>}
        />
    )
})